export const autonomosInitState = {
  devices: {
    dictionary: null,
    list: [],
    allDevices: [],

    filters: {
      category: [],
      query: "",
    },
    modal: {
      isOpen: false,
      addProduct: null,
      modalProps: {
        aliasUrl: null,
        storageList: null,
        colorList: null,
        currentDevice: {
          title: null,
          imgs: null,
          price: null,
        },
      },
    },
    init: false,
  },

  products: {
    devices: {},
  },
};

export const autonomosReducer = {
  GET_DEVICE_DICTIONARY: () => {},

  INIT_DEVICES: (state, { payload }) => {
    state.devices.dictionary = payload.dictionary;
    state.devices.list = payload.list;
    state.devices.allDevices = payload.list;
    state.devices.init = true;
    state.products.devices.products = payload.product;
  },

  INIT_DEVICES_FAIL: (state, { payload }) => {
    state.devices.init = true;
  },

  SET_FILTER: (state, action) => {},

  SET_FILTERED_DEVICES: (state, { payload }) => {
    if (payload?.filters) {
      state.devices.filters.category = payload.filters;
    }

    if (payload?.query) {
      state.devices.filters.query = payload?.query;
    }

    state.devices.list = payload.list;
  },

  SET_DEVICE_QUERY: (state, { payload }) => {
    state.devices.filters.query = payload;
  },

  INIT_PRODUCT_CATEGORIES: (state, { payload }) => {},

  SET_PRODUCT_CATEGORIES: (state, { payload }) => {
    state.products = payload;
  },

  SELECT_PRODUCT: () => {},

  SET_SELECTED_PRODUCT: (state, { payload }) => {
    const { categoryState, category, additionalPrices } = payload;

    state.products[category].products = categoryState;
    state.products[category].additionalPrice = additionalPrices;
  },

  OPEN_DEVICE_MODAL: (state, { payload }) => {},

  SET_DEVICE_MODAL_INFO: (state, { payload }) => {
    const { aliasUrl, currentDevice, storageList, colorList, alias } = payload;

    state.devices.modal.isOpen = true;
    state.devices.modal.modalProps.aliasUrl = aliasUrl;
    state.devices.modal.modalProps.currentDevice = currentDevice;
    state.devices.modal.modalProps.storageList = storageList;
    state.devices.modal.modalProps.colorList = colorList;
    state.devices.modal.modalProps.alias = alias;
  },

  CLOSE_DEVICE_MODAL: (state) => {
    state.devices.modal.isOpen = false;
    state.devices.modal.modalProps.aliasUrl = null;
    state.devices.modal.modalProps.storageList = null;
    state.devices.modal.modalProps.colorList = null;
    state.devices.modal.modalProps.currentDevice = {
      title: null,
      imgs: null,
    };

    state.devices.modal.modalProps.addProduct = null;
  },

  CHANGE_DEVICE_PROP: () => {},

  FILTER_DEVICES_BY_NAME: () => {},

  SET_NEW_DEVICE_PROPS: (state, { payload }) => {
    const { currentDevice, deviceListIndex } = payload;

    state.devices.modal.modalProps.currentDevice = currentDevice;

    if (typeof deviceListIndex === "number") {
      const device = state.devices.list[deviceListIndex];
      state.devices.list[deviceListIndex].image = {
        src: currentDevice?.imgs[0],
      };
      device.imgs = currentDevice?.imgs;
      device.price = currentDevice?.price;
      device.color = currentDevice?.color;
      device.storage = currentDevice?.storage;
    }
  },

  ADD_DEVICE_PRODUCT_MODAL: (state, { payload }) => {
    state.devices.modal.addProduct = payload;
  },
};
